import { render, staticRenderFns } from "./ServiceAir.vue?vue&type=template&id=6615889a&"
import script from "./ServiceAir.vue?vue&type=script&lang=js&"
export * from "./ServiceAir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports